// This file contains the OpenAPI specification used by the Swagger UI

export const apiSpecification = {
  openapi: '3.0.0',
  info: {
    title: 'HOA Document Management API',
    version: '1.0.0',
    description: 'API documentation for HOA document management system',
  },
  servers: [
    {
      url: 'https://aplrbmggxypqwcetxqdo.supabase.co/functions/v1',
      description: 'Production server',
    },
  ],
  components: {
    securitySchemes: {
      bearerAuth: {
        type: 'http',
        scheme: 'bearer',
        bearerFormat: 'JWT',
        description: 'Enter your JWT token',
      },
    },
    schemas: {
      Association: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          name: { type: 'string' },
          association_type: { 
            type: 'string', 
            enum: ['HOA', 'Condominium', 'COOP', 'Other'] 
          },
          email: { type: 'string' },
          phone: { type: 'string' },
          ein: { type: 'string' },
          tax_classification: { 
            type: 'string',
            enum: ['Nonprofit', 'ForProfit', 'Other']
          },
          billing_address: { type: 'string' },
          billing_city: { type: 'string' },
          billing_state: { type: 'string' },
          billing_zip: { type: 'string' },
          default_property_address: { type: 'string' },
          default_property_city: { type: 'string' },
          default_property_state: { type: 'string' },
          default_property_zip: { type: 'string' },
          management_company_id: { type: 'integer' },
          pricing_table_id: { type: 'integer', nullable: true },
          document_groups: { 
            type: 'array',
            items: { type: 'integer' }
          },
          external_id: { type: 'string', nullable: true },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
        },
      },
      NewAssociation: {
        type: 'object',
        required: ['name', 'association_type', 'management_company_id'],
        properties: {
          name: { type: 'string' },
          association_type: { 
            type: 'string', 
            enum: ['HOA', 'Condominium', 'COOP', 'Other'] 
          },
          email: { type: 'string' },
          phone: { type: 'string' },
          ein: { type: 'string' },
          tax_classification: { 
            type: 'string',
            enum: ['Nonprofit', 'ForProfit', 'Other']
          },
          billing_address: { type: 'string' },
          billing_city: { type: 'string' },
          billing_state: { type: 'string' },
          billing_zip: { type: 'string' },
          default_property_address: { type: 'string' },
          default_property_city: { type: 'string' },
          default_property_state: { type: 'string' },
          default_property_zip: { type: 'string' },
          management_company_id: { type: 'integer' },
          pricing_table_id: { type: 'integer', nullable: true },
          document_groups: { 
            type: 'array',
            items: { type: 'integer' }
          },
          external_id: { type: 'string' }
        }
      },
      UpdateAssociation: {
        type: 'object',
        properties: {
          name: { type: 'string' },
          association_type: { 
            type: 'string', 
            enum: ['HOA', 'Condominium', 'COOP', 'Other'] 
          },
          email: { type: 'string' },
          phone: { type: 'string' },
          ein: { type: 'string' },
          tax_classification: { 
            type: 'string',
            enum: ['Nonprofit', 'ForProfit', 'Other']
          },
          billing_address: { type: 'string' },
          billing_city: { type: 'string' },
          billing_state: { type: 'string' },
          billing_zip: { type: 'string' },
          default_property_address: { type: 'string' },
          default_property_city: { type: 'string' },
          default_property_state: { type: 'string' },
          default_property_zip: { type: 'string' },
          pricing_table_id: { type: 'integer', nullable: true },
          document_groups: { 
            type: 'array',
            items: { type: 'integer' }
          },
          external_id: { type: 'string' }
        }
      },
      Document: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          name: { type: 'string' },
          description: { type: 'string' },
          document_type_id: { type: 'integer' },
          publicly_available: { type: 'boolean' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
        },
      },
      DocumentType: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          name: { type: 'string' },
          description: { type: 'string' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
        },
      },
      PricingTable: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          name: { type: 'string' },
          description: { type: 'string' },
          transaction_fees: { 
            type: 'array',
            items: {
              type: 'object',
              properties: {
                fee_id: { type: 'integer' },
                name: { type: 'string' },
                amount: { type: 'number' },
                multiply_by_applicants: { type: 'boolean' },
                married_count_as_one: { type: 'boolean' },
                only_in_rush: { type: 'boolean' },
                apportionment: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      apportionment_party_id: { type: 'integer' },
                      share: { type: 'number' }
                    }
                  }
                }
              }
            }
          },
          document_fees: { 
            type: 'array',
            items: {
              type: 'object',
              properties: {
                document_type_id: { type: 'integer' },
                document_type_name: { type: 'string' },
                fees: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      fee_id: { type: 'integer' },
                      name: { type: 'string' },
                      amount: { type: 'number' },
                      multiply_by_applicants: { type: 'boolean' },
                      married_count_as_one: { type: 'boolean' },
                      only_in_rush: { type: 'boolean' },
                      apportionment: {
                        type: 'array',
                        items: {
                          type: 'object',
                          properties: {
                            apportionment_party_id: { type: 'integer' },
                            share: { type: 'number' }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
        },
      },
      Order: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          customer_id: { type: 'integer' },
          property_id: { type: 'integer' },
          status: { type: 'string', enum: ['pending', 'processing', 'completed', 'cancelled'] },
          total_amount: { type: 'number' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
          items: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: { type: 'integer' },
                order_id: { type: 'integer' },
                item_type: { type: 'string', enum: ['document_fee', 'transaction_fee'] },
                reference_id: { type: 'integer', nullable: true },
                amount: { type: 'number' },
                quantity: { type: 'integer', minimum: 1, default: 1 },
                subtotal_amount: { type: 'number' },
                label: { type: 'string' }
              }
            }
          }
        }
      },
      Property: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          association_id: { type: 'integer' },
          address: { type: 'string' },
          suite_unit: { type: 'string', nullable: true },
          city: { type: 'string', nullable: true },
          state: { type: 'string', nullable: true },
          zip_code: { type: 'string', nullable: true },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
        },
      },
      Customer: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          auth_user_id: { type: 'string', format: 'uuid', description: 'Supabase Auth User ID' },
          is_email_confirmed: { type: 'boolean' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
        },
      },
      CustomerLogin: {
        type: 'object',
        required: ['auth_user_id'],
        properties: {
          auth_user_id: { type: 'string', format: 'uuid' }
        }
      },
      CustomerRegister: {
        type: 'object',
        required: ['auth_user_id'],
        properties: {
          auth_user_id: { type: 'string', format: 'uuid' }
        }
      },
      ErrorResponse: {
        type: 'object',
        properties: {
          error: { type: 'string' },
          details: { type: 'string' }
        }
      },
      ProductType: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          name: { type: 'string' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
        },
      },
      CustomerType: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          name: { type: 'string' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
        },
      },
      FeesApportionParty: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          entity_name: { type: 'string' },
          description: { type: 'string' },
          entity_id: { type: 'integer', nullable: true },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
        },
      },
      PricingCalculationRequest: {
        type: 'object',
        required: ['document_ids', 'association_id'],
        properties: {
          applicants: {
            type: 'object',
            properties: {
              total: { type: 'integer', description: 'Total number of applicants' },
              married: { type: 'integer', description: 'Number of married applicants' }
            }
          },
          delivery: {
            type: 'object',
            properties: {
              rush: { type: 'boolean', description: 'Whether delivery is rushed' }
            },
            description: 'Optional. If not provided, all fees will be included regardless of only_in_rush value'
          },
          document_ids: {
            type: 'array',
            items: { type: 'integer' },
            description: 'IDs of documents to calculate pricing for'
          },
          association_id: { type: 'integer', description: 'ID of the association' }
        }
      },
      PricingCalculationDocumentFee: {
        type: 'object',
        properties: {
          document_id: { type: 'integer', description: 'ID of the document' },
          fees: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                name: { type: 'string', description: 'Name of the fee' },
                fee: { type: 'number', description: 'Amount of the fee' },
                only_in_rush: { type: 'boolean', description: 'Whether this fee only applies to rush orders' },
                multiply_by_applicants: { type: 'boolean', description: 'Whether this fee is multiplied by the number of applicants' },
                married_count_as_one: { type: 'boolean', description: 'Whether married applicants count as one for this fee' },
                quantity: { type: 'integer', description: 'Quantity of the fee (e.g. number of applicants)', minimum: 1, default: 1 },
                subtotal_amount: { type: 'number', description: 'Total amount after applying quantity' }
              }
            }
          },
                      total_amount: { type: 'number', description: 'Total amount for all fees' }
        }
      },
      PricingCalculationResult: {
        type: 'object',
        properties: {
          document_fees: {
            type: 'array',
            items: { 
              $ref: '#/components/schemas/PricingCalculationDocumentFee'
            }
          },
          transaction_fees: {
            type: 'object',
            properties: {
              fees: {
                type: 'array',
                items: {
                  type: 'object',
                  properties: {
                    name: { type: 'string', description: 'Name of the fee' },
                    fee: { type: 'number', description: 'Amount of the fee' },
                    only_in_rush: { type: 'boolean', description: 'Whether this fee only applies to rush orders' },
                    multiply_by_applicants: { type: 'boolean', description: 'Whether this fee is multiplied by the number of applicants' },
                    married_count_as_one: { type: 'boolean', description: 'Whether married applicants count as one for this fee' }
                  }
                }
              },
                              total_amount: { type: 'number', description: 'Total amount for all fees' }
            }
          }
        }
      },
      DocumentForm: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          document_id: { type: 'integer' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
          form_steps: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                id: { type: 'integer' },
                step_order: { type: 'integer' },
                step_title: { type: 'string' },
                next_step_label: { type: 'string' },
                created_at: { type: 'string', format: 'date-time' },
                updated_at: { type: 'string', format: 'date-time' },
                form_sections: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      id: { type: 'integer' },
                      section_order: { type: 'integer' },
                      section_title: { type: 'string' },
                      section_subtitle: { type: 'string' },
                      section_type: { 
                        type: 'string', 
                        enum: ['Default', 'Applicants'] 
                      },
                      multiple_elements: { type: 'boolean', description: 'Whether this section can have multiple elements' },
                      useful_links: {
                        type: 'array',
                        description: 'Links that provide additional information or resources',
                        items: {
                          type: 'object',
                          properties: {
                            label: { type: 'string', description: 'Display text for the link' },
                            url: { type: 'string', description: 'URL that the link points to' }
                          }
                        }
                      },
                      created_at: { type: 'string', format: 'date-time' },
                      updated_at: { type: 'string', format: 'date-time' },
                      form_fields: {
                        type: 'array',
                        items: {
                          type: 'object',
                          properties: {
                            id: { type: 'integer' },
                            field_order: { type: 'integer' },
                            field_type: { type: 'string', enum: ['information', 'text', 'date', 'signature', 'file', 'select'] },
                            label: { type: 'string' },
                            name: { type: 'string', description: 'Field identifier name' },
                            description: { type: 'string' },
                            content: { type: 'string', description: 'HTML content for information fields or JSON string for select options' },
                            filled_by: { type: 'string', enum: ['requestor', 'operations', 'system'] },
                            default_value: { type: 'string' },
                            validation_rules: { type: 'object' },
                            is_required: { type: 'boolean' },
                            created_at: { type: 'string', format: 'date-time' },
                            updated_at: { type: 'string', format: 'date-time' }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      },
      NewFormStep: {
        type: 'object',
        properties: {
          title: { type: 'string' },
          next_step_label: { type: 'string', description: 'Label for the button to proceed to next step' },
          sections: {
            type: 'array',
            items: {
              type: 'object',
              properties: {
                title: { type: 'string' },
                section_type: { type: 'string', enum: ['Default', 'Applicants'] },
                multiple_elements: { type: 'boolean', description: 'Whether this section can have multiple elements' },
                useful_links: {
                  type: 'array',
                  description: 'Links that provide additional information or resources',
                  items: {
                    type: 'object',
                    properties: {
                      label: { type: 'string', description: 'Display text for the link' },
                      url: { type: 'string', description: 'URL that the link points to' }
                    }
                  }
                },
                fields: {
                  type: 'array',
                  items: {
                    type: 'object',
                    properties: {
                      type: { type: 'string', enum: ['information', 'text', 'date', 'signature', 'file', 'select'] },
                      label: { type: 'string' },
                      name: { type: 'string', description: 'Field identifier name' },
                      content: { type: 'string', description: 'HTML content for information fields or array of options for select fields' },
                      filled_by: { type: 'string', enum: ['requestor', 'operations', 'system'] },
                      default_value: { type: 'string' },
                      validation_rules: { type: 'object' },
                      is_required: { type: 'boolean' },
                      options: { 
                        type: 'array', 
                        description: 'Array of options for select fields',
                        items: {
                          type: 'object',
                          properties: {
                            value: { type: 'string' },
                            label: { type: 'string' }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      },
      NewDocumentForm: {
        type: 'object',
        required: ['document_id'],
        properties: {
          document_id: { type: 'integer' },
          steps: {
            type: 'array',
            items: {
              $ref: '#/components/schemas/NewFormStep'
            }
          }
        }
      },
      CMSContent: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          parent_id: { type: 'integer', nullable: true },
          type: { type: 'string', enum: ['layout', 'page', 'email', 'component', 'navigation'] },
          name: { type: 'string' },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' },
          position: { type: 'integer' },
          show_in_menu: { type: 'boolean' }
        }
      },
      CMSContentTranslation: {
        type: 'object',
        properties: {
          id: { type: 'integer' },
          content_id: { type: 'integer' },
          language_code: { type: 'string' },
          title: { type: 'string', nullable: true },
          content: { type: 'string', nullable: true },
          html_content: { type: 'string', nullable: true },
          meta_description: { type: 'string', nullable: true },
          meta_keywords: { type: 'string', nullable: true },
          slug: { type: 'string', nullable: true },
          created_at: { type: 'string', format: 'date-time' },
          updated_at: { type: 'string', format: 'date-time' }
        }
      }
    }
  },
  security: [
    {
      bearerAuth: [],
    },
  ],
  paths: {
    // ... paths will be defined in separate files
  },
};
